var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-menu-button-group"},[(!_vm.collapsed)?_c('p',{staticClass:"group-header"},[_vm._v(_vm._s(_vm.group.name ? _vm.group.name : ''))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }